import { useMemo } from 'react';
import type { LevelData, LevelCardState, LevelCardEffect, Completion } from '../types';
import { isSubPuzzleComplete } from '../store';
import { LevelCardGrid } from './LevelCardGrid';
import './LevelCard.css';

interface LevelCardProps {
  level: LevelData;
  levelIndex: number;
  state: LevelCardState;
  effects?: LevelCardEffect[];
  completions: Record<string, Completion>;
  onPlaySub: (levelIndex: number, subIndex: number) => void;
}

export function LevelCard({
  level,
  levelIndex,
  state,
  effects,
  completions,
  onPlaySub,
}: LevelCardProps) {
  const locked = state === 'locked';

  const revealedCells = useMemo(() => {
    const set = new Set<number>();
    level.puzzles.forEach((p, i) => {
      if (isSubPuzzleComplete(completions, level.id, p.id)) {
        set.add(i);
      }
    });
    return set;
  }, [level, completions]);

  const handleCellClick = (cellIndex: number) => {
    if (locked) return;
    onPlaySub(levelIndex, cellIndex);
  };

  return (
    <LevelCardGrid
      level={level}
      state={state}
      effects={effects}
      revealedCells={revealedCells}
      onCellClick={handleCellClick}
      className="level-card"
    />
  );
}
